export function assetDataFromUMS(upload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    return {
        id: upload.id,
        type: upload.type,
        account: upload.account,
        tenant: upload.tenant,
        createdMs: upload.createdMs,
        createdBy: upload.createdBy,
        modifiedMs: upload.modifiedMs,
        modifiedBy: upload.modifiedBy,
        hash: upload.hash,
        expiresOn: upload.expiresOn,
        properties: upload.properties,
        info: {
            asset: {
                sourceUri: upload.sourceUri,
                folder: upload.folder || ((_b = (_a = upload === null || upload === void 0 ? void 0 : upload.info) === null || _a === void 0 ? void 0 : _a.asset) === null || _b === void 0 ? void 0 : _b.folder),
                expires: upload.expires || ((_d = (_c = upload === null || upload === void 0 ? void 0 : upload.info) === null || _c === void 0 ? void 0 : _c.asset) === null || _d === void 0 ? void 0 : _d.expires),
                folderId: upload.folderId || ((_f = (_e = upload === null || upload === void 0 ? void 0 : upload.info) === null || _e === void 0 ? void 0 : _e.asset) === null || _f === void 0 ? void 0 : _f.folderId),
                hidden: ((_h = (_g = upload === null || upload === void 0 ? void 0 : upload.info) === null || _g === void 0 ? void 0 : _g.asset) === null || _h === void 0 ? void 0 : _h.hidden) || false,
            },
            storage: {
                location: (_j = upload === null || upload === void 0 ? void 0 : upload.info) === null || _j === void 0 ? void 0 : _j.storage.location,
                fileName: (_k = upload === null || upload === void 0 ? void 0 : upload.info) === null || _k === void 0 ? void 0 : _k.storage.fileName,
                fileSizeBytes: (_l = upload === null || upload === void 0 ? void 0 : upload.info) === null || _l === void 0 ? void 0 : _l.storage.fileSizeBytes,
                contentType: (_m = upload === null || upload === void 0 ? void 0 : upload.info) === null || _m === void 0 ? void 0 : _m.storage.contentType,
                contentEncoding: (_o = upload === null || upload === void 0 ? void 0 : upload.info) === null || _o === void 0 ? void 0 : _o.storage.contentEncoding,
                contentDisposition: (_p = upload === null || upload === void 0 ? void 0 : upload.info) === null || _p === void 0 ? void 0 : _p.storage.contentDisposition,
                provider: (_q = upload === null || upload === void 0 ? void 0 : upload.info) === null || _q === void 0 ? void 0 : _q.storage.provider,
            },
            image: (_r = upload === null || upload === void 0 ? void 0 : upload.info) === null || _r === void 0 ? void 0 : _r.image,
            isLogo: (_s = upload === null || upload === void 0 ? void 0 : upload.properties) === null || _s === void 0 ? void 0 : _s.analysisIsLogo,
            isPhoto: (_t = upload === null || upload === void 0 ? void 0 : upload.properties) === null || _t === void 0 ? void 0 : _t.analysisIsPhoto,
            isVector: (_u = upload === null || upload === void 0 ? void 0 : upload.properties) === null || _u === void 0 ? void 0 : _u.analysisIsVector,
        },
        tags: upload.tags,
        _links: upload._links,
    };
}
//# sourceMappingURL=assetData.js.map